function validate({ condition, message, isCritical = false }: GameError) {
  if (condition) throw { message, isCritical };
}

export { validate };
